import { Component, Input } from '@angular/core';
import { LowerCasePipe, NgTemplateOutlet } from '@angular/common';

import { TranslateModule } from '@ngx-translate/core';

import { ImageComponent } from '@atoms/image/image.component';
import { PricePipe } from '@pipes/price.pipe';
import { ThousandsPipe } from '@pipes/thousands.pipe';
import { CarItem } from '@models/car.model';

@Component({
  selector: 'app-car-info-card',
  imports: [LowerCasePipe, NgTemplateOutlet, TranslateModule, ImageComponent, PricePipe, ThousandsPipe],
  templateUrl: './car-info-card.component.html',
  styleUrl: './car-info-card.component.scss',
})
export class CarInfoCardComponent {
  @Input() car?: CarItem;
  @Input() type: 'default' | 'form' = 'default';
  @Input() image?: string;
  @Input() title?: string;
  @Input() price?: number;
  @Input('price-without-vat') priceWithoutVat?: number;
  @Input('hide-price') hidePrice = false;
}
